const inline = (t) => t.split(/(\*\*[^*]+\*\*)/g).map((s, i) => (s.startsWith("**") && s.endsWith("**") ? <strong key={i} className="font-semibold text-zinc-50">{s.slice(2, -2)}</strong> : s));

export const Md = ({ text = "" }) => (
  <div className="space-y-1.5 text-sm leading-relaxed text-zinc-200">
    {text.split("\n").map((l, i) => {
      const t = l.trim();
      if (!t) return <div key={i} className="h-1" />;
      const h = t.match(/^#{1,4}\s+(.*)/);
      if (h) return <div key={i} className="pt-1 font-display text-base text-[#F3C649]">{inline(h[1])}</div>;
      const b = t.match(/^([-*•]|\d+[.)])\s+(.*)/);
      if (b) return <div key={i} className="flex gap-2"><span className="shrink-0 text-[#D4AF37]">{/\d/.test(b[1]) ? b[1] : "•"}</span><span>{inline(b[2])}</span></div>;
      return <p key={i}>{inline(t)}</p>;
    })}
  </div>
);
